<div mat-dialog-title>

  <h2>{{ (data.record ? 'profile.updateWorkExperience' : 'profile.addNewWorkExperience')
    | translate }}</h2>
  <button type="button" class="close" aria-label="Close" mat-dialog-close>
        <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
  <form [formGroup]="formGroup" #form="ngForm">
      <mat-dialog-content>
    <div class="mat-dialog-body">
    <div class="form-group">
      <mat-form-field>
        <mat-label>{{ 'profile.jobTitle' | translate }}</mat-label>
        <input matInput formControlName="jobTitle" maxlength="150">
        <mat-error *ngIf="hasError('jobTitle', 'required')">
          {{ 'profile.jobTitle' | translate }} {{ 'messages.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>{{ 'profile.companyName' | translate }}</mat-label>
        <input matInput formControlName="companyName" maxlength="200">
        <mat-error *ngIf="hasError('companyName', 'required')">
          {{ 'profile.companyName' | translate }} {{ 'messages.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>{{ 'profile.employmentType' | translate }}</mat-label>
        <mat-select formControlName="employmentTypeId">
          @for (item of employmentTypesList; track item.id) {
          <mat-option [value]="item.id">{{item.name}}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="hasError('employmentTypeId', 'required')">
          {{ 'profile.employmentType' | translate }} {{ 'messages.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-card mb">
      <div class="form-card-header">
        {{"tasks.StartDate" | translate}}
      </div>
      <div class="form-card-body">
        <div class="row" formGroupName="startDate">
          <div class="col-6">
            <mat-form-field>
              <mat-label>{{ 'general.Month' | translate }}</mat-label>
              <mat-select formControlName="month">
                @for (item of monthsList; track item.id) {
                <mat-option [value]="item.id">{{item.name}}</mat-option>
                }
              </mat-select>
              <mat-error *ngIf="hasError('month', 'required' , 'startDate')">
                {{ 'general.Month' | translate }} {{ 'messages.required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field>
              <mat-label>{{ 'general.Year' | translate }}</mat-label>
              <mat-select formControlName="year">
                @for (item of yearsList; track item) {
                <mat-option [value]="item.name">{{item.name}}</mat-option>
                }
              </mat-select> <mat-error *ngIf="hasError('year', 'required', 'startDate')">
                {{ 'general.Year' | translate }} {{ 'messages.required' | translate }}
              </mat-error>
            </mat-form-field>

          </div>
        </div>
      </div>
    </div>
    <div class="form-card mb">
      <div class="form-card-header">
        {{"voting.EndDate" | translate}}
      </div>
      <div class="form-card-body">
        <div class="row" formGroupName="endDate">
          <div class="col-6">
            <mat-form-field>
              <mat-label>{{ 'general.Month' | translate }}</mat-label>
              <mat-select formControlName="month">
                @for (item of monthsList; track item.id) {
                <mat-option [value]="item.id">{{item.name}}</mat-option>
                }
              </mat-select>
              <mat-error *ngIf="hasError('month', 'required' , 'endDate')">
                {{ 'general.Month' | translate }} {{ 'messages.required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field>
              <mat-label>{{ 'general.Year' | translate }}</mat-label>
              <mat-select formControlName="year">
                @for (item of yearsList; track item) {
                <mat-option [value]="item.name">{{item.name}}</mat-option>
                }
              </mat-select> <mat-error *ngIf="hasError('year', 'required', 'endDate')">
                {{ 'general.Year' | translate }} {{ 'messages.required' | translate }}
              </mat-error>
            </mat-form-field>

          </div>
          <div class="col-12">
            <small
              *ngIf="formGroup.hasError('dateRangeInvalid') && (formGroup.get('endDate.year')?.touched || formGroup.get('endDate.month')?.touched)"
              class="mat-error mb-3">
              {{ 'profile.endDateBeforeStartDate' | translate }}
            </small>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="slide-toggle">
              <label> {{ 'profile.currentlyWorking' | translate }}</label>
              <mat-slide-toggle class="mx-2" formControlName="currentlyWorking"
                (change)="handelEndDateValue($event)"></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>


    </div>
    </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button type="button" [disabled]="loading" class="btn-grey" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>

    <button mat-raised-button color="primary" (click)="saveRecord()" [ngClass]="{ 'loading': loading}">
 <span>{{ (data.record ? 'profile.updateWorkExperience' : 'profile.addWorkExperience')
          | translate }}</span>
    </button>
  </mat-dialog-actions>
  </form>
